































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { CartTicket, GroupProduct, ProductGroup } from '@openticket/lib-shop';
import { getProductPrice } from './pricing';

interface CheckboxGroupOptions {
    label: string;
    suffix: string;
    description?: string;
    disabled: boolean;
}

@Component
export default class OptionalProductGroupCheckboxItem extends Vue {
    @Prop() ticket!: CartTicket;
    @Prop() productGroup!: ProductGroup;
    @Prop() triggerUpdate!: unknown;

    checked: string[] = [];
    productListener!: string;
    options: { [key: string]: CheckboxGroupOptions } = {};

    created(): void {
        this.update();

        this.productListener = this.$shop.cart.on(
            ['ticket', this.ticket.id, 'product'],
            () => {
                this.update();
            }
        );
    }

    update(): void {
        this.updateChecked();
        this.updateOptions();
    }

    destroyed(): void {
        if (this.productListener) {
            this.$shop.cart.off(this.productListener);
        }
    }

    @Watch('ticket.item', { deep: true, immediate: true })
    updateOptions(): void {
        const map: { [key: string]: CheckboxGroupOptions } = {};
        for (const product of this.productGroup.products) {
            map[product.guid] = {
                label: product.item.name,
                suffix: this.productSuffix(product),
                description: product.item.description,
                disabled: product.item.status != 'available',
            };
        }

        this.options = map;
    }

    productSuffix(product: GroupProduct): string {
        switch (product.item.status) {
            case 'available':
                return this.$l.currency(
                    getProductPrice(product, this.ticket),
                    this.$shop.data.currency as string
                );
            case 'not_sold_right_now':
                return this.$t(
                    'shop.common.ticket_status.not_sold_right_now'
                ) as string;
            case 'sold_out':
                return this.$t('shop.common.ticket_status.sold_out') as string;
        }

        // If not recognized, just return the status.
        // This 'slug' will most likely not be present in translation messages
        // and thus be shown as-is.
        return product.item.status || '';
    }

    updateChecked(): void {
        const checked: string[] = [];
        for (const product of this.productGroup.products) {
            for (const cartProduct of this.ticket.products.collection) {
                if (product.guid === cartProduct.item.guid) {
                    checked.push(product.guid);
                }
            }
        }
        this.checked = checked;
    }

    onInputChanged(newValue: string[]): void {
        for (const guid of [...newValue, ...this.checked]) {
            if (!newValue.includes(guid)) {
                this.$emit('remove', guid);
            } else if (!this.checked.includes(guid)) {
                this.$emit('add', guid);
            }
        }
    }

    @Watch('triggerUpdate')
    onTriggerUpdate(): void {
        this.updateChecked();
    }
}
